"use client";

import { Button, type buttonVariants } from "@/components/ui/button";
import { useConnectUser } from "@/hooks/use-connect-user";
import { trpc } from "@/util/trpc";
import type { VariantProps } from "class-variance-authority";
import { Loader2 } from "lucide-react";

export function YouTubeChannelConnectButton({
    relativeRedirectUrl,
    className,
    cta,
    variant,
}: { relativeRedirectUrl?: string; className?: string; cta?: string } & VariantProps<typeof buttonVariants>) {
    const { connect } = useConnectUser();
    const generateGoogleOauthUrl = trpc.lambda.users.generateGoogleOauthUrl.useMutation();
    const click = async () => {
        if (connect("signup") === "already-connected") {
            const url = await generateGoogleOauthUrl.mutateAsync({ relativeRedirectUrl });
            window.open(url, "_self");
        }
    };

    return (
        <Button
            disabled={generateGoogleOauthUrl.isPending || generateGoogleOauthUrl.isSuccess}
            className={className}
            onClick={() => {
                void click();
            }}
            variant={variant}
        >
            {(generateGoogleOauthUrl.isPending || generateGoogleOauthUrl.isSuccess) && (
                <Loader2 className="mr-2 animate-spin" />
            )}
            {cta != null ? cta : "Connect YouTube Channel"}
        </Button>
    );
}
